// import Home from "./component/home/Home";

import Homes from "./container/Homes";



function App() {
  return (
    <>
      <Homes/>
      {/* <Home/> */}
    </>
  );
}

export default App;
